export default [
  'yahoo',
  'outlook',
  'hotmail',
  'gmail',
  'aol',
  'icloud',
  'skype',
]
